import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

import states from 'rise-ui/config/states.js';
import { keyForAttribute, keyForRelationship } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  name:               'locationName',
  description:        'locationDescription',
  type:               'locationTypeName',
  coordinates:        'locationCoordinates',
  reclamationRegions: 'locationRegionNames',
  unifiedRegions:     'locationUnifiedRegionNames',
  tags:               'locationTags',
  locationParentId:   { relationship: 'parentLocation' },
  relatedLocationIds: { relationship: 'relatedLocations' },
})
@keyForRelationship({
  states: {
    attribute: 'states',
    map: ({ id }) => ({ abbr: id, name: states[id] }),
  },
})
export default class LocationSerializer extends DataAPISerializer {}
